import LoadingSkeleton from '@v2/commons/components/LoadingSkeletonRows/LoadingSkeletonRows.component'
import { PropsWithChildren, Suspense } from 'react'

type Props = {
  rows: number
} & PropsWithChildren

const SuspenseFallback = ({ children, rows }: Props) => {
  return (
    <Suspense
      fallback={
        <LoadingSkeleton
          maxRange={rows}
          height={20}
          mt={8}
          stackProps={{ mb: 8 }}
        />
      }
    >
      {children}
    </Suspense>
  )
}

export default SuspenseFallback
